import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=5f1b1948&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.css?vue&type=style&index=0&id=5f1b1948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b1948",
  null
  
)

export default component.exports